/**
 * ColorPicker registration: the parser, which reads the VBoxContainer
 * properties and the ColorPicker members that change a drawn row.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseColorPicker } from './parser';
const colorPickerRegistration = {
    typeName: 'ColorPicker',
    parser: parseColorPicker,
};
nodeRegistry.register(colorPickerRegistration);
//# sourceMappingURL=index.js.map